var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tincan"}},[_vm._m(0),_c('canvas',{attrs:{"id":"canvas"},on:{"mousemove":_vm.mouseMove}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"text404"}},[_c('div',{attrs:{"id":"title404"}},[_vm._v("404")]),_c('div',{attrs:{"id":"sub404"}},[_vm._v("Page Not Found")])])
}]

export { render, staticRenderFns }